import { recommendClient, RecommendClient } from '@algolia/recommend'
import CartPlugin from '../CartPlugin'
import { useUpsellsStore } from './stores/upsellsStore'
import { Cart, ICartPluginHandlers } from '../../types'

class UpsellsPlugin extends CartPlugin implements Partial<ICartPluginHandlers> {
  private algoliaClient!: RecommendClient
  private indexPrefix!: string
  private debounceTimeout: NodeJS.Timeout | null = null
  private debounceMs = 500

  constructor({ enabled = true }) {
    super(enabled)

    if (!this.enabled) return

    try {
      const algoliaConfig = window.Lounge?.integrations?.algolia
      if (
        !algoliaConfig ||
        !algoliaConfig.apiKey ||
        !algoliaConfig.appId ||
        !algoliaConfig.indexPrefix
      ) {
        console.error(
          'UpsellsPlugin: Algolia config (apiKey, appId, indexPrefix) missing from window.Lounge.integrations.algolia',
        )
      }
      this.algoliaClient = recommendClient(
        algoliaConfig.appId,
        algoliaConfig.apiKey,
      )
      this.indexPrefix = algoliaConfig.indexPrefix
    } catch (error) {
      console.error('UpsellsPlugin: Error initializing Algolia client:', error)
    }
  }

  private triggerFetchUpsellsWithDebounce = (cart: Cart | undefined | null) => {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }
    this.debounceTimeout = setTimeout(() => {
      if (!this.enabled || !this.algoliaClient || !this.indexPrefix) {
        console.warn(
          'UpsellsPlugin not fully initialized or disabled, skipping fetch.',
        )
        return
      }
      const { fetchUpsells } = useUpsellsStore.getState()
      fetchUpsells(cart, this.algoliaClient, this.indexPrefix)
    }, this.debounceMs)
  }

  onAddItems = (cart: Readonly<Cart>): Cart => {
    this.triggerFetchUpsellsWithDebounce(cart)
    return cart
  }

  onRemoveItems = (cart: Readonly<Cart>): Cart => {
    this.triggerFetchUpsellsWithDebounce(cart)
    return cart
  }

  onUpdate = (cart: Readonly<Cart>): Cart => {
    this.triggerFetchUpsellsWithDebounce(cart)
    return cart
  }

  onFormatCart = (cart: Readonly<Cart>): Cart => {
    this.triggerFetchUpsellsWithDebounce(cart)
    return cart
  }

  onClear = (cart: Readonly<Cart>): Cart => {
    this.triggerFetchUpsellsWithDebounce(cart)
    return cart
  }
}

export { UpsellsPlugin }
